import React from 'react';
import { NavLink } from "react-router-dom";
export default function PageNotFound() {
    return (
        <div>
            <h1>Page Not Found</h1>
            <NavLink to="/">
                home
            </NavLink>
        </div>
    );
}